<template>
  <i class="material-icons mr-1 text-yellow-500">warning</i>
</template>
